let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("40Tt1")).then(() => parcelRequire('lV02N'));